/**
 * Dictation anywhere's keys as caps: the start/stop shortcut and the fixed
 * prompt keys (⌘ 1 on macOS, Windows + 1 on Windows).
 */
import { ShortcutKeyCaps } from "@/components/ui";
import { describeShortcut } from "@/lib/shortcut-registry";
import {
  bindingKeyCaps,
  promptStopBinding,
  shortcutKeys,
  spokenShortcut,
} from "@/lib/shortcuts";
import {
  DICTATION_SHORTCUT,
  useDictationShortcutBinding,
} from "./voice-dictation-keys";

/** The start/stop shortcut as key caps. */
export function DictationShortcutCaps() {
  useDictationShortcutBinding();
  return (
    <ShortcutKeyCaps
      keys={shortcutKeys(DICTATION_SHORTCUT.testId)}
      label={spokenShortcut(DICTATION_SHORTCUT.testId)}
    />
  );
}

/** Prompt `number`'s key as caps. */
export function PromptKeyCaps({ number }: { number: number }) {
  const binding = promptStopBinding(number);
  return (
    <ShortcutKeyCaps
      keys={bindingKeyCaps(binding)}
      label={describeShortcut(binding)}
    />
  );
}
